/**
 * Email check for admin forms. Same pattern as the API's EMAIL_REGEX
 * (ca-rootsfundme-api app/common/validators.js, the WHATWG/HTML5 rule an
 * <input type="email"> uses), so the form never refuses an address the API
 * accepts. It allows "+" in the local part and domain labels of any length.
 * The old sign-in regex refused both (D11, 2026-10-03): an invited consultant
 * with such an address was approved but could never sign in.
 */
const EMAIL_REGEX = /^[\w.!#$%&'*+/=?^`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)*$/i;
const EMAIL_MAX_LENGTH = 225; // users.email column width

export function isValidEmail(value) {
  if (typeof value !== "string") return false;
  const email = value.trim(); // the API trims (and lower-cases) before validating
  if (email.length === 0 || email.length > EMAIL_MAX_LENGTH) return false;
  return EMAIL_REGEX.test(email);
}
